export const assetChrawnna = {
  id: 567,
  height: 414147,
  data: {
    icon: "/imgs/icons/asset/chrawnna.svg",
    about:
      "This is a community and incentive token for WagMedia. It will now act as a gov token.",
    links: [
      {
        name: "Twitter",
        url: "https://twitter.com/thatMediaWag",
        icon: "/imgs/icons/link-x.svg",
      },
    ],
    governances: [
      {
        spaceLogo: "/imgs/icons/asset/chrawnna.svg",
        spaceName: "Chrawnna",
        projectName: "Chrawnna",
        link: "https://voting.opensquare.io/space/chrwna",
      },
    ],
  },
};
